export var BankCardType;
(function (BankCardType) {
    BankCardType["ETC"] = "ETC";
    BankCardType["BANK"] = "BANK";
    BankCardType["CARD"] = "CARD";
    BankCardType["KIOSK"] = "KIOSK";
})(BankCardType || (BankCardType = {}));
